import React, { Component } from 'react';
import { formatoDecimal } from '../../../utilities/formatoNumeros'
import {
    descargarObleaVentaVerdeApi,
    fetchComprobanteVentaVerdeApi,
    guardarDescargaObleaVentaVerdeApi
} from '../../../api/axios'
import { base64ToArrayBuffer, saveByteArray, saveByteArrayJpg } from "../../../utilities/formatFile";
import { toast } from 'react-toastify';
import { filtroHoy } from "../../../utilities/fechasFiltro";
import MiniSpinner from "../../General/MiniSpinner";

export default class OrdenProvListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            obleaDescargada: this.props.obleaDescargada,
            showSpinner: false
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.obleaDescargada !== this.props.obleaDescargada) {
            this.setState({ obleaDescargada: this.props.obleaDescargada });
        }
    }

    descargarOblea = (e) => {
        e.preventDefault();

        this.setState({ showSpinner: true });
        let factura = descargarObleaVentaVerdeApi({ IdVenta: parseInt(e.target.id) });

        factura.then(res => {
            let pdfData = base64ToArrayBuffer(res.oblea);
            saveByteArrayJpg("Oblea.pdf", pdfData);
            toast.success("Descarga realizada");

            const { idOrden, userId } = this.props;

            let guardar = guardarDescargaObleaVentaVerdeApi({
                idUsuario: userId,
                IdOrden: idOrden,
                FechaDescarga: filtroHoy(),
                Borrado: true,
                FechaActualizacion: filtroHoy()
            });

            guardar.then(res => {
                toast.success("Estado actualizado");
                this.setState({ obleaDescargada: true });
            }).catch(() => {
                toast.error("El estado de la oblea no pudo ser actualizado");
            });
        }).catch((err) => {
            (err.response.data.error)
                ? err.response.data.error.forEach(err => toast.error(err))
                : toast.error("No pudo descargarse la oblea");
        }).finally(() => {
            this.setState({ showSpinner: false });
        });
    }

    descargarComprobante = (e) => {
        e.preventDefault();
        let factura = fetchComprobanteVentaVerdeApi({ comprobante: e.target.id });
        factura.then(res => {
            let pdfData = base64ToArrayBuffer(res.factura);
            saveByteArray("Factura", pdfData);
            toast.success("Descarga realizada");
        }).catch(err => {
            toast.error("Descarga fallida");
        });
    }

    render = () => {
        const {
            idOrden,
            fecha,
            cliente,
            montoVenta,
            productos,
            mailCliente,
            dniIdBocaSeller,
            plataformaCodigo,
            comprobante
        } = this.props;

        const switchLogo = (plataformaCodigo) => {
            switch (plataformaCodigo) {
                case 0:
                    return '/img/icono-megatone.png'
                case 1:
                    return '/img/icono-mega-Market.png'
                case 2:
                    return '/img/icono-megatone-express.png'
                default:
                    return ""
            }
        }

        return (
            <div className="container bg-white shadow-sm rounded mb-2 py-3 border hover-shadow" style={{ transition: 'all 0.2s' }}>
                <div className="row align-items-center">

                    <div className="col-12 col-md-2 col-lg-1 text-center text-break border-end-md">
                        <span className="d-block fw-bold text-dark">{fecha.slice(0, 10)}</span>
                        <small className="d-block text-muted">{idOrden}</small>
                    </div>

                    <div className="col-12 col-md-2 text-center border-end-md">
                        <div className="font-weight-bold text-dark text-break my-1">
                            {cliente}
                        </div>
                        <small hidden={mailCliente.length < 1} className="text-muted d-block text-truncate">
                            {mailCliente}
                        </small>
                        <div className="d-flex align-items-center justify-content-center mt-1">
                            <img
                                src={process.env.PUBLIC_URL + switchLogo(plataformaCodigo)}
                                alt=""
                                className="img-fluid me-1"
                                style={{ maxWidth: "20px", maxHeight: "20px" }}
                            />
                            <small className="text-secondary fw-bold">
                                {dniIdBocaSeller !== 0 ? dniIdBocaSeller : ""}
                            </small>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-5 col-12 align-self-center py-2 px-md-4">
                        {
                            productos.map((producto, index, { length }) => {
                                return (
                                    <div className="row mb-2 align-items-center" key={index}>
                                        <div className="col-3 col-md-2 text-center">
                                            <img
                                                alt={producto?.titulo}
                                                className="img-fluid rounded border"
                                                src={producto.imagenPrincipal !== ""
                                                    ? producto.imagenPrincipal
                                                    : "https://www.megatone.net/Images/Marketplaces/EnProceso_zoom2x.png"
                                                }
                                                style={{ maxHeight: '50px' }}
                                            />
                                        </div>
                                        <div className="col-9 col-md-10">
                                            <h6 className="mb-0 font-weight-bold text-dark line-height-sm">
                                                <span className="badge bg-light text-dark me-2 border rounded-pill">{producto.cantidad}</span>
                                                <small className="text-dark bg-transparent font-weight-bold">{producto.titulo}</small>
                                            </h6>
                                            <div className="d-flex flex-wrap gap-2 mt-1">
                                                <small className="text-muted me-3">
                                                    Unitario: <strong>${formatoDecimal(producto.precioUnitario)}</strong>
                                                </small>
                                                <small className="text-muted">
                                                    SKU: {producto.skuMarket}
                                                </small>
                                            </div>
                                        </div>
                                        <div className="col-12 border-bottom my-2" hidden={index + 1 === length} />
                                    </div>
                                )
                            })
                        }
                    </div>

                    <div className="col-12 col-md-2 text-center border-start-md">
                        <h5 className="font-weight-bold text-success mb-0">${formatoDecimal(montoVenta)}</h5>
                        <small className="text-muted">Total</small>
                    </div>

                    <div className="col-12 col-md-2 text-center">
                        <div className="d-grid gap-2">
                            {this.state.showSpinner ? <MiniSpinner /> :
                                <button
                                    type="button"
                                    onClick={this.descargarOblea}
                                    id={idOrden}
                                    className={`btn btn-sm ${this.state.obleaDescargada ? "btn-outline-success" : "btn-primary"}`}
                                >
                                    {this.state.obleaDescargada ? "Re-descargar Oblea" : "Descargar Oblea"}
                                </button>
                            }
                            <button
                                type="button"
                                onClick={this.descargarComprobante}
                                id={comprobante}
                                className="btn btn-sm btn-outline-secondary"
                            >
                                Comprobante
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        );

    }
}